<template>
    <div>
        <div class="container-fluid mt-45">
            <div class="row">
                <div class="col-md-6">
                    <Breadcrumbs />
                </div>

                <div class="col-md-6 text-right">
                    <button @click="cancelTest()" class="btn btn-danger btn-cancel-test btn-block-mobile btn-lg lg-shadow mt-4 mt-md-0">Cancel test</button>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <h5>Please enter the correct delivery address</h5>

                            <div class="row mt-4">
                                <div class="col-lg-4">
                                    <template v-if="organisationCountryCode == 'GB'">
                                        <UkAddressComponent
                                            :labelColSize="Number(4)"
                                            :inputColSize="Number(8)"
                                        />

                                        <hr />
                                    </template>

                                    <template v-if="organisationCountryCode == 'US'">
                                        <UsAddressComponent
                                            :labelColSize="Number(4)"
                                            :inputColSize="Number(8)"
                                        />

                                        <hr />
                                    </template>

                                    <template v-if="organisationCountryCode == 'QA'">
                                        <QaAddressComponent
                                            :labelColSize="Number(4)"
                                            :inputColSize="Number(8)"
                                        />

                                        <hr />
                                    </template>

                                    <template v-if="organisationCountryCode == 'AE'">
                                        <AeAddressComponent
                                            :labelColSize="Number(4)"
                                            :inputColSize="Number(8)"
                                        />

                                        <hr />
                                    </template>

                                    <template v-if="organisationCountryCode == 'SG'">
                                        <SgAddressComponent
                                            :labelColSize="Number(4)"
                                            :inputColSize="Number(8)"
                                        />

                                        <hr />
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fixed-bottom bg-white py-25">
            <div class="container-fluid">
                <div class="row">
                    <div class="col text-right center-mobile">
                        <router-link :to="{name: 'ConfirmDeliveryAddress'}" class="btn btn-cancel btn-lg px-5 lg-shadow">Back</router-link>
                        <button @click="next()" class="btn btn-success btn-lg px-6 lg-shadow ml-2">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import CancelTestModalComponent from '@/components/modals/CancelTestModalComponent.vue'
import FormatterMixin from '../../../Common/mixins/FormatterMixin'
import UkAddressComponent from '../../../Common/components/UkAddressComponent.vue'
import UsAddressComponent from '../../../Common/components/UsAddressComponent.vue'
import QaAddressComponent from '../../../Common/components/QaAddressComponent.vue'
import AeAddressComponent from '../../../Common/components/AeAddressComponent.vue'
import SgAddressComponent from '../../../Common/components/SgAddressComponent.vue'
import AddressComponentValidationMixin from '../../../Common/mixins/AddressComponentValidationMixin'
export default {
    name: 'DeliveryAddress',

    components: {
        Breadcrumbs,
        UkAddressComponent,
        UsAddressComponent,
        QaAddressComponent,
        AeAddressComponent,
        SgAddressComponent
    },

    mixins: [
        FormatterMixin,
        AddressComponentValidationMixin
    ],

    data() {
        return {
            loading: false,
            isBusy: false,
            error: false,
            CancelTestModalComponent
        }
    },

    mounted() {
        if(!this.patientName && !this.facilityId && !this.patientId && !this.patientTitle && !this.dueDate && !this.reason && this.shippingAddressType !== 0) {
            return this.$router.push({name: 'Dashboard'})
        }

        this.setCountryCodeInAddressStore(this.organisationCountryCode)
    },

    computed: {
        ...mapGetters({
            organisationCountryCode: 'OrganisationStore/GetMyOrganisationCountryCode',
            patientName: 'TestStore/GetPatientName',
            facilityId: 'TestStore/GetFacilityId',
            patientId: 'TestStore/GetPatientId',
            patientTitle: 'TestStore/GetPatientTitle',
            dueDate: 'TestStore/GetDueDate',
            reason: 'TestStore/GetReason',
            deviceId: 'TestStore/GetDeviceId',
            deliveryAddress: 'TestStore/GetDeliveryAddress',
            shippingAddressType: 'TestStore/GetShippingAddressType',
            address: 'AddressFormStore/GetAddress',
            addressErrors: 'AddressFormStore/GetAddressErrors'
        }),

        deviceIdComputed: {
            get: function() {
                return this.deviceId
            },

            set: function(val) {
                this.setDeviceIdInTestStore(val)
            }
        }
    },

    methods: {
        ...mapActions({
            setDeliveryAddressInTestStoreAction: 'TestStore/SetDeliveryAddress',
            setNotification: 'NotificationStore/SetNotification',
            setCountryCodeInAddressStore: 'AddressFormStore/SetCountryCode',
        }),

        async next() {
            this.expandManualAddress()
            this.checkAddress()

            if(!Object.keys(this.addressErrors).length) {
                await this.setDeliveryAddressInTestStoreAction(this.address)
                this.$router.push({name: 'Confirmation'})
            }
        },

        cancelTest() {
            this.$modal.show(CancelTestModalComponent, {}, {width: '400px'});
        }
    }
}
</script>